import { styled, Box } from "@mui/material";

export const WrapperUIRoot = styled(Box)(({ theme }) => ({
  display: "block",
  height: "100vh",
  width: "100vw",
}));
